import React from 'react';
import { setCurrentView } from 'core/utils';
import ExportInventoryByDateModalTemplate from 'themes/modules/order/pages/ExportInventoryByDateModalTemplate';
import ExportInventoryByDateModalViewStore from '../stores/ExportInventoryByDateModalViewStore';

@setCurrentView((rootStore, componentProps) => new ExportInventoryByDateModalViewStore(rootStore, componentProps), 'exportInventoryByDateModalViewStore')
class ExportInventoryByDateModal extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ExportInventoryByDateModalTemplate {...this.props} />;
	}
}

export default ExportInventoryByDateModal;
